export const lessons = {
  opposition: {
    title: "One square makes all the difference.",
    subtitle: "King & pawn endings",
    fen: "8/8/4k3/8/4K3/3P4/8/8 w - - 0 1",
    text: "Opposition is a relationship between kings. When they face each other with one square between them, the player who must move has to give way. Here White is to move: the kings have direct opposition, but Black holds it. Explore how a pawn move can change whose turn it is. Opposition is a tool for reaching useful squares, not a guarantee that a pawn will promote.",
    question: "Try advancing the pawn. What changes about whose turn it is?",
  },
  development: {
    title: "Give every piece a purpose.",
    subtitle: "Opening understanding",
    fen: "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - 2 3",
    text: "After 1.e4 e5 2.Nf3 Nc6, White can develop the bishop to c4, pointing toward f7, or to b5, putting pressure on the knight that defends e5. These lead to different plans. Develop, make your king safe, and ask how each move helps the next piece.",
    question:
      "Try Bc4 and Bb5 in separate branches. Which position would you rather play?",
  },
  calculation: {
    title: "Think in possibilities. Then verify.",
    subtitle: "Calculation studio",
    fen: "6k1/5ppp/8/8/8/8/5PPP/4R1K1 w - - 0 1",
    text: "Before touching a piece, name your candidate moves. Begin with checks, then captures, then threats. For each candidate, look for the opponent’s strongest reply. This position is a simple starting point: find a forcing move and check every escape square.",
    question:
      "Write your predicted line in the coach, then test it on the board.",
  },
} as const;
export const curriculum = [
  {
    title: "A crowded back rank",
    fen: "6k1/5ppp/8/8/8/8/5PPP/4R1K1 w - - 0 1",
    concept: "Look at the king’s escape squares before choosing a check.",
  },
  {
    title: "The same idea, another file",
    fen: "1k6/ppp5/8/8/8/8/PPP5/1K1R4 w - - 0 1",
    concept:
      "A pawn shield can also trap its own king. Look for a forcing check.",
  },
  {
    title: "See it from the other side",
    fen: "4r1k1/5ppp/8/8/8/8/5PPP/6K1 b - - 0 1",
    concept: "Check every flight square. Apply the back-rank idea with Black.",
  },
];
